import { useBuildingStore } from '../../stores/buildingStore'
import { useViewStore } from '../../stores/viewStore'

export default function FloorList() {
  const floors = useBuildingStore((s) => s.floors)
  const locations = useBuildingStore((s) => s.locations)
  const selectedFloor = useViewStore((s) => s.selectedFloor)
  const isolatedFloor = useViewStore((s) => s.isolatedFloor)
  const selectFloor = useViewStore((s) => s.selectFloor)
  const isolateFloor = useViewStore((s) => s.isolateFloor)

  if (floors.length === 0) return null

  const sorted = [...floors].sort((a, b) => b.index - a.index)

  return (
    <div className="floor-list">
      <div className="panel-section__title">Etages</div>
      {sorted.map((floor) => {
        const zoneCount = locations.filter((l) => l.floor === floor.index).length
        const isSelected = selectedFloor === floor.index
        const isIsolated = isolatedFloor === floor.index

        return (
          <button
            key={floor.id}
            className={`floor-list__item${isSelected ? ' floor-list__item--selected' : ''}${isIsolated ? ' floor-list__item--isolated' : ''}`}
            onClick={() => selectFloor(isSelected ? null : floor.index)}
            onDoubleClick={() => isolateFloor(floor.index)}
          >
            <span className="floor-list__name">{floor.name}</span>
            <span className="floor-list__count">{zoneCount} zones</span>
          </button>
        )
      })}
    </div>
  )
}
